import { render, staticRenderFns } from "./ServiceLineItem.vue?vue&type=template&id=0c66bab4&scoped=true&lang=pug&"
import script from "./ServiceLineItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceLineItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceLineItem.vue?vue&type=style&index=0&id=0c66bab4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c66bab4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFlex,VLayout,VSpacer})
